export const config = {
    appname: 'dior',
    client_id: '187688842321785', // App ID
    facebook_app_id: '187688842321785', // Facebook App ID (Should be the same)
    debug: false, //enable console.log

    // ------------- Production Settings ----------------
    agency_id: '39511',
    bzbsUrl: 'https://apidil.buzzebees.com',
    bzbsServiceUrl: 'https://apidil2.buzzebees.com',
    bzbsModuleUrl: 'https://diormodule.buzzebees.com',
    bzbsAddItemFromList: 'https://shoppingcartmodule32.buzzebees.com/cart/',
    bzbsBlobUrl: 'https://buzzebees.blob.core.windows.net',
    bzbsShoppingCartUrl: 'https://shoppingcartservice32.buzzebees.com',
    apiShoppingCartUrl: 'https://shoppingcartmodule32.buzzebees.com',
    bzbsAddItem: 'https://cart.buzzebees.com/payment/AddItem.aspx?id=',
    bzbsShoppingBasket: 'https://cart.buzzebees.com/paymentV2/cart.aspx',
    bzbsWebUrl: 'https://www.buzzebees.com',
    bzbsPointExpire: 'https://www.buzzebees.com/Views/Point/Expire.aspx?token=',
    miscUrl: 'https://misc.buzzebees.com',
    bzbsGaId: '',
    liffId: '',
    // ------------------ End Settings ---------------------
    fbLogOnUrl: 'https://www.facebook.com/dialog/oauth?',
    fbPermissions: [
        'email',
    ],
    mainConfig: {
    },
};
